import { render, staticRenderFns } from "./landing-brandStore.vue?vue&type=template&id=886ee564&scoped=true"
import script from "./landing-brandStore.vue?vue&type=script&lang=js"
export * from "./landing-brandStore.vue?vue&type=script&lang=js"
import style0 from "./landing-brandStore.vue?vue&type=style&index=0&id=886ee564&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "886ee564",
  null
  
)

export default component.exports